import {AxiosInstance} from "axios"
import {AuctionSettings, Codes, User} from "domain-models"
import Echo from "laravel-echo"
import {PusherConnector} from "laravel-echo/dist/connector"
import {applyMiddleware, compose, createStore, Store} from 'redux'
import thunk from 'redux-thunk'
import {AppState} from "redux/reducers/AppReducer"
import {GlobalState} from "state"
import rootReducers from './redux/reducers'

type WindowType = Window & typeof globalThis & {
  app: AppState,
  Popper: any
  $: JQuery
  jQuery: JQuery
  axios: AxiosInstance
  user: User
  codes: Codes
  settings: AuctionSettings
  Pusher: PusherConnector
  Echo: Echo
  __forceSmoothScrollPolyfill__: boolean
  __REDUX_DEVTOOLS_EXTENSION_COMPOSE__: any
}

const composeEnhancers = (window as WindowType).__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose

export const store: Store<GlobalState> = createStore(
  rootReducers,
  composeEnhancers(
    applyMiddleware(thunk)
  )
)
